<app-uni-page  [parent]="this" *ngIf="isPageReady" pageTitle="Administration: Access" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-list-actions">
          <div class="flex items-center gap-2">
          </div>
          <div class="flex items-center gap-2">
            <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-plus" (click)="addUser()">
              <span>Add User</span>
            </button>
          </div>
        </div>
        <app-ag-grid [gridOptions]="userGridOptions" [rowData]="users" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-child-actions">
          <h5 class="m-0">Roles &amp; Capabilities — {{ selectedUser?.FirstName }} {{ selectedUser?.LastName }}</h5>
        </div>
        <app-ag-grid [gridOptions]="roleGridOptions" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>